<template>
      <div class="container">
        <h2 slot="header">Shop users</h2>
        <div slot="body">
          {{$route.params.id}}
        </div>
      </div>
</template>

<script>
    export default {
        name: 'shop-users',
        components: {

        },
        props: {
            
        },
        data () {
            return {
               
            }
        },
        computed: {
           
        },
        methods: {
            
        },
    }
</script>
